import { render } from "./ConfirmSubmitModal.vue?vue&type=template&id=6ae69218"
import script from "./ConfirmSubmitModal.vue?vue&type=script&lang=js"
export * from "./ConfirmSubmitModal.vue?vue&type=script&lang=js"
script.render = render

export default script